var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2",
    type: "text/css"
  }, "\n    .st3{fill:none;stroke:#31352e;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "g2062",
    transform: "matrix(.2 0 0 .2 -.8 -.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyline4",
    d: "m94 52.5 15.6-4.6 7.2-8.3",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyline6",
    d: "m90.6 99.4 16.3 8.6 5 9.5",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyline8",
    d: "M97 76h16l8 6.3",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyline10",
    d: "m34 52.5-15.6-4.6-7.2-8.3",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyline12",
    d: "M37.4 99.4 21.1 108l-5 9.5",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyline14",
    d: "M31 76H15l-8 6.3",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line16",
    d: "M50.299999 21.700001 40.599998 12",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line18",
    d: "M77.699997 21.700001 87.400002 12",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M68.441406 18.736328c-9.123617 1.952168-16.251057 9.31614-17.841797 18.462891-3.199996 1.199999-6.099221 3.001564-8.699218 5.101562l-.699219-1.296875c-.000132.03207-.002.06361-.002.0957l.701172 1.300782c5.199994-4.399996 11.898835-7 19.298828-7h5.500047c6.899993 0 13.201177 2.299613 18.201172 6.099609l1.90039-.400391c0-11.079732-7.88876-20.298742-18.359375-22.363281z",
    style: {
      fill: "var(--primary-color)",
      fillOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M68.6 18.7c-1.5-.3-3-.5-4.6-.5-12.6 0-22.8 10.2-22.8 22.8l.7 1.3c2.6-2.1 5.5-3.9 8.7-5.1 1.6-9.2 8.8-16.6 18-18.5z",
    style: {
      fill: "var(--primary-color)",
      fillOpacity: 0.47
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M68.308594 35.044922c.233608.01478.47135.02325.691406.05469-6.499993.5-12.399614 3.199614-17.099609 7.09961-7.699993 6.399993-12.099608 16.701573-10.59961 27.601562l2.798828 19.398438c1.099999 7.499992 4.799615 14.001568 10.09961 18.601558 4.083626 3.58562 9.160724 5.97919 14.734375 6.98633 12.792352-2.1218 23.10151-12.3405 24.966797-25.486326l2.798828-19.40039C98.299217 58.400402 93.399992 47.600775 85 41.300781c-4.632762-3.520899-10.383356-5.921596-16.691406-6.255859Z",
    style: {
      fill: "var(--primary-color)",
      fillOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M54.2 107.8c-5.3-4.6-9-11.1-10.1-18.6l-2.8-19.4c-1.5-10.9 2.9-21.2 10.6-27.6 4.7-3.9 10.6-6.6 17.1-7.1-.7-.1-1.5-.1-2.2-.1h-5.6c-7.4 0-14.1 2.8-19.3 7.2-7.7 6.5-12.1 16.7-10.6 27.6l2.8 19.4c1.1 7.4 4.8 14 10.1 18.6 5.3 4.6 12.3 7.4 19.8 7.4 1.7 0 3.4-.1 5-.4-5.6-1-10.7-3.4-14.8-7z",
    style: {
      fill: "var(--primary-color)",
      fillOpacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M41.2 41.1c0-12.6 10.2-22.8 22.8-22.8 12.6 0 22.8 10.2 22.8 22.8",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line32",
    d: "M64 115V47.400002",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M41.9 42.4c5.2-4.3 11.9-7 19.3-7h5.6c6.9 0 13.2 2.3 18.2 6.1 8.4 6.4 13.4 17 11.7 28.4l-2.8 19.3c-2.1 14.9-14.9 26-29.9 26-7.5 0-14.5-2.8-19.8-7.4-5.3-4.6-9-11.1-10.1-18.6l-2.8-19.3C29.8 59 34.2 48.8 41.9 42.4Z",
    className: "st3",
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.09285d30f4d39f2090f744d8e7cb3b4e.svg";
export { ForwardRef as ReactComponent };